import * as actionType from "../actions/types";

const INITIAL_STATE = {
  name: "",
  mail: "",
  type: "",
  file: false, //este dato se puso false y no null, por que genera un error en formik en el onboarding paso 2
  personaForm: {
    name: "",
    lastName: "",
    dniCuil: "",
    profession: "",
    tel: "",
    address: "",
    webSite: "",
  },
  empresaForm: {
    cuit: "",
    companyName: "",
    field: "",
    tel: "",
    address: "",
    webSite: "",
  },
  cities: [],
  codeValidation: false,
  isValidating: false,
  identityModal: { isOpen: false, emailToValidate: "" },
  usersBySkill: [],
  selectedJurisdictions: [],
  searchSkill: [],
  skillsList: [],
  totalPages: 0,
  totalSkillsListed: 0,
  selectedSkill: [],
  usersSkillList: [],
  userSkills: [],
  skills: [],
  userPortfolios: [],
  openEdit: false,
  portfolioId: null,
  workBagUsers: [],
  workBagUsersToValidate: [],
  currentWorkOffer: {},
  workOfferPostulation: false,
  allJobRequests: [],
  plans: [],
  userPlan: {},
  planID: null,
  terminosStatus: false,
  errorMessage: "",
  itemCount: 0,
  page: 0,
  portfoliosLoading: false,
  // Nuevos estados para el flow de registro
  isPreRegistering: false,
  preRegisterError: null,
  isCodeValidating: false,
  codeValidationError: null,
  codeValidationData: null, // Para guardar la respuesta exitosa
  isResendingCode: false,
  resendCodeError: null,
  // Nuevos estados para completar registro
  isCompletingRegistration: false,
  completeRegistrationError: null,
  completeRegistrationData: null,
};

const clearUserSkills = (state) => {
  return {
    ...state,
    userSkills: [],
  };
};

const addSkillToUser = (state, skillId) => {
  // Ensure skills and userSkills are arrays
  const skillsArray = state.skills || [];
  const userSkillsArray = state.userSkills || [];

  let skill = skillsArray.find((element) => {
    return element.id === skillId;
  });
  
  // If skill is not found, return state unchanged
  if (!skill) {
    return state;
  }
  
  let add = userSkillsArray.find((elSkill) => {
    return elSkill.id === skill.id;
  });
  if (!add) {
    return {
      ...state,
      userSkills: userSkillsArray.concat(skill),
    };
  } else {
    return {
      ...state,
    };
  }
};

const removeUserSkill = (state, skillId) => {
  const userSkillsArray = state.userSkills || [];
  let userSkill = userSkillsArray.filter((element) => {
    return element.id !== skillId;
  });

  return {
    ...state,
    userSkills: userSkill,
  };
};

const registerReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.REGISTER_SUCCESS:
      return {
        ...state,
        name: action.payload.name,
        mail: action.payload.mail,
      };
    case actionType.VALIDATION_SUCCESS:
      return {
        ...state,
        codeValidation: action.payload,
      };
    case actionType.SET_IS_VALIDATING:
      return {
        ...state,
        isValidating: action.payload,
      };
    case actionType.OPEN_IDENTITY_MODAL:
      return {
        ...state,
        identityModal: {isOpen: action.payload, emailToValidate: action.email},
      };
    case actionType.CHANGE_TYPE:
      return {
        ...state,
        type: action.payload,
      };
    case actionType.SET_FILE:
      return {
        ...state,
        file: action.payload,
      };
    case actionType.SET_PORTFOLIO:
      return {
        ...state,
        portfolios: action.payload,
      };
    case actionType.GET_PORTFOLIO_LOADING:
      return {
        ...state,
        portfoliosLoading: action.payload,
      };
    case actionType.GET_CITIES: {
      return {
        ...state,
        cities: action.payload,
      };
    }
    case actionType.GET_ALL_JOB_REQUESTS:
      return {
        ...state,
        allJobRequests: action.payload,
      };
    case actionType.CURRENT_WORK_OFFER: {
      return {
        ...state,
        currentWorkOffer: action.payload,
      };
    }
    case actionType.GET_ALL_WORKBAG_USERS: {
      return {
        ...state,
        workBagUsers: action.payload,
      };
    }
    case actionType.SEND_WORK_OFFER_POSTULATION: {
      return {
        ...state,
        workOfferPostulation: action.payload,
      };
    }
    case actionType.FILTER_WORKBAG_USERS: {
      return {
        ...state,
        workBagUsers: action.payload,
      };
    }
    case actionType.GET_PLANS:
      return {
        ...state,
        plans: action.payload,
      };
    case actionType.SEARCH_SKILL:
      return {
        ...state,
        searchSkill: action.payload,
      };
    case actionType.GET_USER_SKILL:
      return {
        ...state,
        userSkills: action.payload,
      };
    case actionType.SET_SKILLS:
      return {
        ...state,
        skills: action.payload,
      };
    case actionType.SET_SKILLS_LIST:
      return {
        ...state,
        skillsList: action.payload,
      };
    case actionType.SET_USERS_BY_SKILL:
      return {
        ...state,
        usersBySkill: action.payload.users,
        selectedJurisdictions: action.payload.jurisdictionIds,
        selectedSkill: action.payload.selectedSkill,
        page: action.payload.page,
        itemCount: action.payload.itemCount,
      };
    case actionType.RESET_SELECTEDSKILL:
      return {
        ...state,
        selectedSkill: [],
      };
    case actionType.SET_USERS_IN_SKILL_NAME:
      return {
        ...state,
        usersSkillList: action.payload.userList,
        totalPages: action.payload.totalPages,
        totalSkillsListed: action.payload.totalSkillsListed,
      };
    case actionType.CLEAR_USER_SKILLS:
      return clearUserSkills({ ...state });
    case actionType.ADD_SKILL:
      return addSkillToUser({ ...state }, action.payload);
    case actionType.REMOVE_SKILL:
      return removeUserSkill({ ...state }, action.payload);
    case actionType.GET_USER_PLAN:
      return {
        ...state,
        userPlan: action.payload,
      };
    case actionType.SET_TERMINOS:
      return {
        ...state,
        terminosStatus: !state.terminosStatus,
      };
    case actionType.SET_PLANID:
      return {
        ...state,
        planID: action.payload,
      };
    case actionType.REGISTER_FAIL:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case actionType.SET_PERSONA_FORM:
      return {
        ...state,
        personaForm: action.payload,
        file: action.file,
      };
    case actionType.SET_EMPRESA_FORM:
      return {
        ...state,
        empresaForm: action.payload,
        file: action.file,
      };
    case actionType.CLEAR_ONBOARDING_FORM:
      return {
        ...state,
        empresaForm: INITIAL_STATE.empresaForm,
        personaForm: INITIAL_STATE.personaForm,
        file: INITIAL_STATE.file,
      };
    case actionType.FETCH_IDENTITY_PHOTOS_WORKERS_REQUEST:
      return { ...state, loading: true, error: null };
    case actionType.FETCH_IDENTITY_PHOTOS_WORKERS_SUCCESS:
      return { ...state, loading: false, workBagUsersToValidate: action.payload };
    case actionType.FETCH_IDENTITY_PHOTOS_WORKERS_FAILURE:
      return { ...state, loading: false, error: action.error };
    case actionType.PRE_REGISTER_START:
      return {
        ...state,
        isPreRegistering: true,
        preRegisterError: null,
      };
              case actionType.PRE_REGISTER_SUCCESS:
      return {
        ...state,
        isPreRegistering: false,        
        preRegisterError: null,
      };
    case actionType.PRE_REGISTER_FAIL:
      return {
        ...state,
        isPreRegistering: false,
        preRegisterError: action.payload,
      };
    case actionType.CODE_VALIDATION_START:
      return {
        ...state,
        isCodeValidating: true,
        codeValidationError: null,
      };
    case actionType.CODE_VALIDATION_SUCCESS:
      return {
        ...state,
        isCodeValidating: false,
        codeValidationError: null,
        codeValidationData: action.payload, 
      };
    case actionType.CODE_VALIDATION_FAIL:
      return {
        ...state,
        isCodeValidating: false,
        codeValidationError: action.payload,
      };
    case actionType.RESEND_CODE_START:
      return {
        ...state,
        isResendingCode: true,
        resendCodeError: null,
      };
    case actionType.RESEND_CODE_SUCCESS:
      return {
        ...state,
        isResendingCode: false,
        resendCodeError: null,
      };
          case actionType.RESEND_CODE_FAIL:
        return {
          ...state,
          isResendingCode: false,
          resendCodeError: action.payload,
        };
    case actionType.COMPLETE_REGISTRATION_START:
      return {
        ...state,
        isCompletingRegistration: true,
        completeRegistrationError: null,
      };
    case actionType.COMPLETE_REGISTRATION_SUCCESS:
      return {
        ...state,
        isCompletingRegistration: false,
        completeRegistrationError: null,
        completeRegistrationData: action.payload,
      };
    case actionType.COMPLETE_REGISTRATION_FAIL:
      return {
        ...state,
        isCompletingRegistration: false,
        completeRegistrationError: action.payload,
      };
    case actionType.CLEAR_REGISTRATION_FLOW:
      return {
        ...state,
        // Limpiar solo los estados del flujo de registro
        isPreRegistering: false,
        preRegisterError: null,
        isCodeValidating: false,
        codeValidationError: null,
        codeValidationData: null,
        isResendingCode: false,
        resendCodeError: null,
        // Limpiar estados de completar registro
        isCompletingRegistration: false,
        completeRegistrationError: null,
        completeRegistrationData: null,
      };
    default:
      return state
  }
}

export default registerReducer;